import { useEffect, useState } from 'react'

/**
 * Returns `true` once `deadline` is in the past.
 * Uses a single `setTimeout` (no polling) so the component re-renders
 * exactly once, at the moment the deadline expires.
 */
export function useHasDeadlinePassed(
  deadline: Date | null | undefined
): boolean {
  const [hasPassed, setHasPassed] = useState(() => {
    if (!deadline) return false
    return Date.now() >= deadline.getTime()
  })

  useEffect(() => {
    if (!deadline) {
      setHasPassed(false)
      return
    }

    const remaining = deadline.getTime() - Date.now()

    if (remaining <= 0) {
      setHasPassed(true)
      return
    }

    setHasPassed(false)
    const timer = setTimeout(() => setHasPassed(true), remaining)
    return () => clearTimeout(timer)
  }, [deadline])

  return hasPassed
}
